<template>
  <select-artist
    :is-shown="isShown"
    :selected-ids="selectedIds"
    modal-name="selectCopyrightArtist"
    modal-class="select-copyright-artist-modal"
    title="著作者公表名選択"
    :artist-type="1"
    :kana-optional="true"
    @close="onClose"
    @select="onSelect" />
</template>

<script>
import SelectArtist from './SelectArtist'

export default {
  name: 'SelectCopyrightArtist',
  components: { SelectArtist },
  props: {
    isShown: {
      type: Boolean,
      default: false,
    },
    selectedIds: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    onClose() {
      this.$emit('close')
    },
    onSelect(artists) {
      this.$emit('select', artists)
    },
  },
}
</script>
